import React, { Component } from "react";
import { connect } from "react-redux";
import { withCookies } from "react-cookie";
import Announcements from "./announcements.json";
import _ from "lodash";
import moment from "moment";
import { config } from "../../utils/conf";
import "./style.css";
import ConfirmationModal from "../Modal/ConfirmationModal";

class Announcement extends Component {
  state = {
    showNotification: false,
    announcements: [],
    currentIndex: 0,
  };

  componentDidMount = () => {
    let announcements = this.getActiveAnnouncement();
    this.setState({ announcements }, () => {
      this.announce();
    });
  };

  announce = () => {
    const { cookies } = this.props;
    const { announcements } = this.state;
    if (_.isEmpty(announcements)) {
      return;
    }

    const key = this.generateKey();
    let previousIds = cookies.get(key) || [];

    const unseenAnnouncements = announcements.filter(
      (announcement) => !previousIds.includes(announcement.id.toString()),
    );

    if (unseenAnnouncements.length > 0) {
      this.setState({ showNotification: true });
    }
  };

  generateKey = () => {
    const userName = _.kebabCase(this.props.session.user.UserName);
    return `TOSCA-ANNOUNCEMENT-${userName}`;
  };

  getActiveAnnouncement = () => {
    let items = Announcements;
    let result = _.filter(items, (item) => {
      return (
        moment(moment.now()).isBetween(item.start, item.end, "day", "[]") &&
        item.active &&
        (item.users || []).includes(this.props.session.customerType)
      );
    });
    return _.orderBy(result, "id", "desc");
  };

  dontShowAgain = (e) => {
    e.preventDefault();
    const { cookies } = this.props;
    const { announcements } = this.state;
    const key = this.generateKey();
    const ids = announcements.map((a) => a.id.toString());
    cookies.set(key, ids);
    this.hide();
  };

  hide = () => {
    this.setState({ showNotification: false });
  };

  show = () => {
    this.setState({ showNotification: true });
  };

  nextAnnouncement = () => {
    this.setState((prevState) => ({
      currentIndex:
        (prevState.currentIndex + 1) % prevState.announcements.length,
    }));
  };

  prevAnnouncement = () => {
    this.setState((prevState) => ({
      currentIndex:
        (prevState.currentIndex - 1 + prevState.announcements.length) %
        prevState.announcements.length,
    }));
  };

  render() {
    let { showNotification, announcements, currentIndex } = this.state;
    if (!showNotification || _.isEmpty(announcements)) {
      return null;
    }
    const announcement = announcements[currentIndex];
    let links = announcement && announcement.links ? announcement.links : [];
    return (
      <ConfirmationModal
        size="2xl"
        title={announcement.title}
        brand="primary"
        show={true}
        onClose={this.hide}>
        <p>
          <span className="tw-text-lg md:tw-text-xl tw-font-normal tw-text-dark">
            {announcement.subtitle}
          </span>
        </p>
        <p
          className="text-align-left tw-text-justify tw-leading-relaxed tw-tracking-wide announcement"
          dangerouslySetInnerHTML={{ __html: announcement.body }}></p>
        <div className="modal-btns">
          {links.map((link, index) => {
            const linkUrl = link.url.replace("{docUrl}", config.docUrl);
            return (
              <form
                key={index}
                action={linkUrl}
                method="GET"
                target="_blank"
                className="tw-block">
                <button type="submit" className="tw-w-full">
                  {link.title}
                </button>
              </form>
            );
          })}

          {announcements.length > 1 && (
            <div className="tw-flex tw-justify-center tw-items-center tw-my-4">
              <button
                onClick={this.prevAnnouncement}
                className="tw-px-2 tw-py-1 tw-border">
                &lt;
              </button>
              <span className="tw-px-4">
                {currentIndex + 1} of {announcements.length}
              </span>
              <button
                onClick={this.nextAnnouncement}
                className="tw-px-2 tw-py-1 tw-border">
                &gt;
              </button>
            </div>
          )}

          <div className="tw-flex tw-justify-center">
            <a
              href="/"
              role="button"
              onClick={this.dontShowAgain}
              className="tw-italic tw-text-sm tw-underline tw-text-center tw-text-gray-600">
              Don't show this again
            </a>
          </div>
        </div>
      </ConfirmationModal>
    );
  }
}

const mapState = ({ login, session }) => ({
  login: login,
  session: session,
});

export default withCookies(connect(mapState)(Announcement));
